import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
} from "../../components/CustomComponent.js";
import { data } from "react-router";

export default class WarehouseManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_type: "",
      filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,

      // Form States (Modal)
      uid: "",
      company_id: company?.id || "", // Default company_id from your cURL
      branch: "",
      warehouse_code: "",
      warehouse_type: "",
      name: "",
      description: "",
      location_id: "",
      location_list_id: [],
      is_active: "Active",

      // List Data
      data: [],
      data_location: [],
      data_warehouse: [],
      data_branch: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count, data_location, data_warehouse, data_branch;
    loading(true);

    // Call GET API Warehouse
    let [result, result_location, result_warehouse, result_branch] = await Promise.all([
      GET("warehouse/warehouses", {
        page_size: 10,
        page: page,
        data_search: filter_search || "",
        warehouse_type: this.state.filter_type || "",
        is_active: this.state.filter_status || "",
      }),
      GET("warehouse/locations", {
        page_size: 1000,
        page: 0,
        is_warehouse: false
      }),
      GET("warehouse/warehouses", {
        page_size: 100000,
        page: 0,
        data_search: filter_search || "",
        warehouse_type: this.state.filter_type || "",
        is_active: this.state.filter_status || "",
      }),
      GET("warehouse/branches", {
        page_size: 1000,
        page: 0,
        is_active: "true",
      })
    ]);

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }
    if (result_location?.status) {
      data_location = result_location.data.map(d => ({value: d.uid, label: `${d.location_code} ${d.name}`})); // For dropdown usage
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data;
    }
    if (result_branch?.status) {
      data_branch = result_branch.data.map(d => ({ value: d.name, label: d.name })); // For dropdown usage
    }

    this.setState({ data: data || [], count, data_location: data_location || [], data_warehouse: data_warehouse || [], data_branch: data_branch || [] });
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      branch,
      warehouse_code,
      warehouse_type,
      name,
      description,
      location_id,
      location_list_id,
      is_active,
    } = this.state;

    // Validation
    if (!warehouse_code.trim()) {
      alert("", "warning", t("warning"), t("verify_warehouse_code"));
      return;
    } else if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_warehouse_name"));
      return;
    } else if (!warehouse_type.trim()) {
      alert("", "warning", t("warning"), t("verify_warehouse_type"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      // Request Body
      let body = {
        company_id,
        branch,
        warehouse_code,
        warehouse_type,
        name,
        description,
        location_list_id: location_list_id.map(loc => loc.value || loc),
        is_active: is_active === "Active",
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/warehouses", body)
        : await PUT("warehouse/warehouses/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/warehouses/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      branch: "",
      warehouse_code: "",
      warehouse_type: "",
      name: "",
      description: "",
      location_id: "",
      is_active: "Active",
      location_list_id: []
    });
  };

  // 2. ฟังก์ชันสำหรับเพิ่ม Location ลงใน Table (Array)
  handleAddLocation = () => {
    const { selected_location_id, data_location, location_list_id } = this.state;
    
    if (!selected_location_id) return;

    // เช็คว่าเคยเพิ่ม location นี้ไปแล้วหรือยัง
    const isDuplicate = location_list_id.some(loc => loc.value === selected_location_id);
    if (isDuplicate) {
      alert("", "warning", t("warning"), t("location_already_added"));
      return;
    }

    // หาข้อมูล Location จาก data_location
    const selectedLocation = data_location.find(loc => loc.value === selected_location_id);
    
    if (selectedLocation) {
      this.setState({
        location_list_id: [...location_list_id, selectedLocation],
        selected_location_id: "" // รีเซ็ต Dropdown
      });
    }
  };

  // 3. ฟังก์ชันสำหรับลบ Location ออกจาก Table
  handleRemoveLocation = (indexToRemove) => {
    this.setState((prevState) => ({
      location_list_id: prevState.location_list_id.filter((_, index) => index !== indexToRemove)
    }));
  };

  render() {
    const {
      data,
      data_location,
      data_warehouse,
      count,
      filter_search,
      filter_type,
      filter_status,
      modal_create,
      modal_update,
      branch,
      warehouse_code,
      warehouse_type,
      name,
      description,
      location_id,
      is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("warehouse_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_warehouses_desc")}</div>
                    </div>
                </div>

                {/* Top KPI Cards */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("total_warehouses")}</div>
                                    <h4 className="fw-bold text-dark mb-0">{data_warehouse.length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">
                                    {"\uf49e"} {/* Warehouse icon */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("active_warehouses")}</div>
                                    <h4 className="fw-bold text-success mb-0">{data_warehouse.filter((d) => d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf4fc"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("inactive_warehouses")}</div>
                                    <h4 className="fw-bold text-secondary mb-0">{data_warehouse.filter((d) => !d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary border d-flex align-items-center justify-content-center text-18 icon">{"\uf4fa"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_warehouses")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                />
                            </div>
                            <select className="form-select wpx-150" value={filter_type} onChange={(e) => this.setState({ filter_type: e.target.value })}>
                                <option value="">{t("all_types")}</option>
                                <option value="main">{t("main_warehouse")}</option>
                                <option value="sub">{t("sub_warehouse")}</option>
                            </select>
                            <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                                <option value="">{t("all_status")}</option>
                                <option value="true">{t("active")}</option>
                                <option value="false">{t("inactive")}</option>
                            </select>
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_status: "", filter_type: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_warehouse")}
                        </button>
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Warehouses Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0 wpx-250">{t("warehouse")}</th>
                                    <th className="py-3 border-0 wpx-150">{t("type")}</th>
                                    <th className="py-3 border-0 wpx-150">{t("branch")}</th>
                                    <th className="py-3 border-0 wpx-250">{t("description")}</th>
                                    <th className="py-3 border-0 wpx-250">{t("storage_area")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Warehouse Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    <span className="icon">{"\uf49e"}</span>
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                    <div className="text-secondary text-10">
                                                        {t("code")}: {item.warehouse_code}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Type */}
                                        <td>
                                            <span className={`badge bg-primary-light text-primary rounded-pill px-2 py-1 fw-bold text-10 border border-primary`}>
                                                {t("warehouse_" + item.warehouse_type)}
                                            </span>
                                        </td>

                                        {/* Branch */}
                                        <td>
                                            <div className="text-secondary text-14">{item.branch}</div>
                                        </td>

                                        {/* Description */}
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "200px" }}>
                                                {item.description || "-"}
                                            </div>
                                        </td>
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "200px" }}>
                                                {item?.locations?.map((e) => e.name)}
                                            </div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex justify-content-center gap-3 text-16">
                                                <span
                                                    className="icon text-primary pointer hover-primary transition-hover"
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            ...item,
                                                            location_id: item.location?.uid || "", // Set location_id for dropdown
                                                            is_active: item.is_active ? "Active" : "Inactive",
                                                            location_list_id: item.locations?.map((loc) => ({ value: loc.uid, label: `${loc.location_code} ${loc.name}` })) || [],
                                                        });
                                                    }}
                                                >
                                                    {"\uf044"}
                                                </span>
                                                <span
                                                    className="icon text-danger pointer hover-danger transition-hover"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                >
                                                    {"\uf2ed"}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {count} {t("warehouses_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT WAREHOUSE */}
            <Modal
                size="lg"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_warehouse") : t("add_new_warehouse")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("warehouse_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-md-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("branch")} <span className="text-danger">*</span>
                                    </label>
                                    <select className="form-select py-2" value={this.state.branch} onChange={(e) => this.setState({ branch: e.target.value })}>
                                        <option value="">{t("select_branch")}</option>
                                        {/* Keep current value visible even if it is no longer an active branch */}
                                        {this.state.branch && !this.state.data_branch.some((b) => b.value === this.state.branch) && (
                                            <option value={this.state.branch}>{this.state.branch}</option>
                                        )}
                                        {this.state.data_branch.map((b, i) => (
                                            <option key={i} value={b.value}>{b.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("warehouse_code")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="e.g. W-001"
                                        value={this.state.warehouse_code}
                                        onChange={(e) => this.setState({ warehouse_code: e.target.value })}
                                        disabled={modal_update} // Typically code shouldn't be changed
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("warehouse_name")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" className="form-control py-2" placeholder="e.g. Main Warehouse" value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
                                </div>

                                <div className="col-md-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("warehouse_type")} <span className="text-danger">*</span>
                                    </label>
                                    <select className="form-select py-2" value={this.state.warehouse_type} onChange={(e) => this.setState({ warehouse_type: e.target.value })}>
                                        <option value="">{t("select_type")}</option>
                                        <option value="main">{t("main")}</option>
                                        <option value="sub">{t("sub")}</option>
                                    </select>
                                </div>

                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                                    <textarea
                                        className="form-control py-2"
                                        rows="3"
                                        placeholder={t("warehouse_description")}
                                        value={this.state.description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Locations Section (Array & Table) */}
                        <div className="col-12 mt-4 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf041"}</span> {t("storage_area")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("warehouse_locations_desc")}</small>

                            {/* Select & Add Button */}
                            <div className="d-flex gap-2 mb-3">
                                <select className="form-select py-2" value={this.state.selected_location_id || ""} onChange={(e) => this.setState({ selected_location_id: e.target.value })}>
                                    <option value="">{t("select_location")}</option>
                                    {this.state.data_location?.map((loc) => (
                                        <option key={loc.value} value={loc.value}>
                                            {loc.label}
                                        </option>
                                    ))}
                                </select>
                                <button type="button" className="btn btn-primary px-4 fw-bold text-nowrap" onClick={this.handleAddLocation}>
                                    + {t("add")}
                                </button>
                            </div>

                            {/* Locations Table */}
                            <div className="table-responsive border rounded-3 bg-white">
                                <table className="table table-hover align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="py-2 px-3 text-dark text-14 border-bottom-0">{t("location_name")}</th>
                                            <th className="py-2 px-3 text-center wpx-100 text-dark text-14 border-bottom-0">{t("actions")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.location_list_id && this.state.location_list_id.length > 0 ? (
                                            this.state.location_list_id.map((loc, index) => (
                                                <tr key={index}>
                                                    <td className="py-2 px-3 text-14">{loc.label}</td>
                                                    <td className="py-2 px-3 text-center">
                                                        <span
                                                            className="icon text-danger pointer hover-danger transition-hover text-16"
                                                            onClick={() => this.handleRemoveLocation(index)}
                                                            title={t("remove")}
                                                        >
                                                            {"\uf2ed"} {/* Trash Icon */}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2" className="text-center py-4 text-muted text-14">
                                                    {t("no_location_selected")}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-4 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("status_desc")}</small>
                            <div className="d-flex gap-4">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="warehouseStatus"
                                        id="statusActive"
                                        checked={this.state.is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="warehouseStatus"
                                        id="statusInactive"
                                        checked={this.state.is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
